import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText',
  standalone: true
})
export class TruncateTextPipe implements PipeTransform {
  transform(value: string | null | undefined, limit: number = 260): string {
    if (!value) return '';

    const cleanValue = value.trim();

    if (cleanValue.length <= limit) {
      return cleanValue;
    }

    return `${cleanValue.substring(0, limit).trim()}...`;
  }
}